// extracted by mini-css-extract-plugin
export default {"container":"SponsorBlockBar_container__usXIL","segment":"SponsorBlockBar_segment__ZMmXs"};